module.exports = __webpack_public_path__ + "img/failure.f5824e01.png";